import { Col } from 'antd';
import { fieldAccessOptions } from './FieldAccessOptions';
import { PERISCOPE_FILTER_PLACEHOLDER } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { OptionFilter, SearchFilter, SearchFilterContainer } from '../filters';
export const ProfileSearch = ({ onChange }) => React.createElement(SearchFilterContainer, null,
    React.createElement(Col, { span: 12 },
        React.createElement(SearchFilter, { onChange: onChange })),
    React.createElement(Col, { span: 12 },
        React.createElement(OptionFilter, { onChange: (value) => onChange({ hasEditAccess: value ? value === 'true' : null }), options: fieldAccessOptions, placeholder: PERISCOPE_FILTER_PLACEHOLDER.FILTER_BY_ACCESS })));
